export const DESCRICAO_ASSISTENCIAS = {
  assistencia_24h: "Assistência 24h",
  vidros: "Vidros",
  carro_reserva: "Carro Reserva",
  pequenos_reparos: "Pequenos Reparos",
  despesas_higienização: "Despesas Higienização",
};
